module.exports = __webpack_public_path__ + "img/Step4.865d4aa5.jpg";